export const CURRENCY_DELIMITER = "'"

export const SUPPORTED_LANGUAGES = ['en']

export const CURRENCIES = {
  DEFAULT: 'QBX',
  QBX: '$QBX',
  VIR: 'VIR'
}

export const ENV_PRODUCTION = 'production'

export const MAX_PERCENTAGE = 100

export const REFRESH_AVAILABLE_BALANCE_INTERNAL = 3000 // 3 seconds

export const ALERT_DISAPPEAR_TIME = 10000 // 10 seconds
export const INFO_ALERT_DISAPPEAR_TIME = 60000 // 60 seconds

export const DISABLE_CLAIM = false

export const STATIC_REWARD_APY = 36

export const QUEST_TAP_POOL_ID = 'quest_tap_pool'
export const HOLDERS_UNLOCK_MULTIFARM = 'holders_unlock_multifarm'

export const CLAIM_CURRENCY_TYPE = { QBX: 'qbx', VIR: 'vir' }

export const CONTRACT_ID_FOR_CUSTOM_FLOW = {
  [QUEST_TAP_POOL_ID]: 10,
  [HOLDERS_UNLOCK_MULTIFARM]: 22
}

export const VIP_CLUB_URL = 'https://vip.qiibeefoundation.org'
